import { createActions, createReducer } from 'reduxsauce'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    createBookingRequest: ['data'],
    fetchingMyBookingRequest: ['options'],
    fetchingMyAppointmentRequest: ['options'],
    confirmingBookingRequest: ['bookingId'],
    cancellingBookingRequest: ['bookingId'],

    createBookingSuccess: ['booking'],
    fetchingMyBookingSuccess: ['result'],
    fetchingMyAppointmentSuccess: ['result'],
    confirmBookingSuccess: ['message'],
    cancelBookingSuccess: ['message'],

    createBookingFailure: ['error'],
    fetchingMyBookingFailure: ['error'],
    fetchingMyAppointmentFailure: ['error'],
    confirmBookingFailure: ['error'],
    cancelBookingFailure: ['error'],
})

export const BookingTypes = Types
export const BookingActions = Creators

/* ------------- Initial State ------------- */
const INITIAL_STATE = {
    creating: false,
    gettingMyBookings: false,
    gettingMyAppointment: false,
    confirmingBookingId: null,
    cancellingBookingId: null,

    createSuccess: null,
    myBookingSuccess: null,
    myAppointmentSuccess: null,
    confirmSuccess: null,
    cancelSuccess: null,

    createError: null,
    getMyBookingError: null,
    getMyAppointmentError: null,
    confirmError: null,
    cancelError: null,
}

/* ------------- Reducers ------------- */
//request
const createBookingRequest = (state) => ({
    ...state, creating: true, createSuccess: null
})
const fetchingMyBookingRequest = (state) => ({
    ...state, gettingMyBookings: true, myBookingSuccess: null
})
const fetchingMyAppointmentRequest = (state) => ({
    ...state, gettingMyAppointment: true, myAppointmentSuccess: null
})

const confirmingRequest = (state, action) => ({
    ...state, confirmingBookingId: action.bookingId, confirmSuccess: null
})

const cancellingRequest = (state, action) => ({
    ...state, cancellingBookingId: action.bookingId, cancelSuccess: null
})

//success
const createBookingSuccess = (state, action) => {
    const { booking } = action
    return ({ ...state, creating: false, createSuccess: booking, createError: null }
    )
}
const fetchingMyBookingSuccess = (state, action) => {
    const { result } = action
    return ({ ...state, gettingMyBookings: false, myBookingSuccess: result, getMyBookingError: null }
    )
}
const fetchingMyAppointmentSuccess = (state, action) => {
    const { result } = action
    return ({ ...state, gettingMyAppointment: false, myAppointmentSuccess: result, getMyAppointmentError: null }
    )
}
const confirmSuccessful = (state, action) => {
    const { message } = action
    return ({ ...state, confirmingBookingId: null, confirmSuccess: message, confirmError: null }
    )
}
const cancelSuccessful = (state, action) => {
    const { message } = action
    return ({ ...state, cancellingBookingId: null, cancelSuccess: message, cancelError: null }
    )
}

//failure
const createBookingFailure = (state, action) => {
    const { error } = action
    return ({ ...state, creating: false, createSuccess: null, createError: error })
}
const fetchingMyBookingFailure = (state, action) => {
    const { error } = action
    return ({ ...state, gettingMyBookings: false, myBookingSuccess: null, getMyBookingError: error })
}
const fetchingMyAppointmentFailure = (state, action) => {
    const { error } = action
    return ({ ...state, gettingMyAppointment: false, myAppointmentSuccess: null, getMyAppointmentError: error })
}
const confirmingFailure = (state, action) => {
    const { error } = action
    return ({ ...state, confirmingBookingId: null, confirmSuccess: null, confirmError: error })
}
const cancellingFailure = (state, action) => {
    const { error } = action
    return ({ ...state, cancellingBookingId: null, cancelSuccess: null, cancelError: error })
}

/* ------------- Hook Types to Reducers ------------- */
export default createReducer(INITIAL_STATE, {
    [Types.CREATE_BOOKING_REQUEST]: createBookingRequest,
    [Types.FETCHING_MY_BOOKING_REQUEST]: fetchingMyBookingRequest,
    [Types.FETCHING_MY_APPOINTMENT_REQUEST]: fetchingMyAppointmentRequest,
    [Types.CONFIRMING_BOOKING_REQUEST]: confirmingRequest,
    [Types.CANCELLING_BOOKING_REQUEST]: cancellingRequest,

    [Types.CREATE_BOOKING_SUCCESS]: createBookingSuccess,
    [Types.FETCHING_MY_BOOKING_SUCCESS]: fetchingMyBookingSuccess,
    [Types.FETCHING_MY_APPOINTMENT_SUCCESS]: fetchingMyAppointmentSuccess,
    [Types.CONFIRM_BOOKING_SUCCESS]: confirmSuccessful,
    [Types.CANCEL_BOOKING_SUCCESS]: cancelSuccessful,

    [Types.CREATE_BOOKING_FAILURE]: createBookingFailure,
    [Types.FETCHING_MY_BOOKING_FAILURE]: fetchingMyBookingFailure,
    [Types.FETCHING_MY_APPOINTMENT_FAILURE]: fetchingMyAppointmentFailure,
    [Types.CONFIRM_BOOKING_FAILURE]: confirmingFailure,
    [Types.CANCEL_BOOKING_FAILURE]: cancellingFailure,
})